export default __webpack_public_path__ + "static/media/icon-truck-red.b63c3055.jpg";